import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
// import Licenses from './views/Licenses.vue';
// import HospitalHome from './views/hospital/Info.vue';
Vue.use(Router);
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/resetpass',
            name: 'resetPass',
            component: () => import(/* webpackChunkName: "resetPassByForget" */ './views/user/ResetPassByForget.vue'),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: 'hospital',
                    name: 'Hospital',
                    component: () => import(/* webpackChunkName: "hospitalIndex" */ './views/hospital/Index.vue'),
                    children: [
                        {
                            path: 'info',
                            name: 'HospitalInfo',
                            component: () => import(/* webpackChunkName: "hospitalInfo" */ './views/hospital/Info.vue')
                        },
                        {
                            path: 'detail',
                            name: 'Detail',
                            component: () => import(/* webpackChunkName: "hospitalInfoDetail" */ './views/hospital/InfoDetail.vue')
                        },
                        {
                            path: 'person',
                            name: 'Person',
                            component: () => import(/* webpackChunkName: "hospitalPerson" */ './views/hospital/Person.vue')
                        },
                        {
                            path: 'his',
                            name: 'His',
                            component: () => import(/* webpackChunkName: "dispenseHis" */ './views/hospital/His.vue')
                        },
                        {
                            path: 'recipel',
                            name: 'RecipelRecord',
                            component: () => import(/* webpackChunkName: "dispenseRecipelRecord" */ './views/hospital/RecipelRecord.vue')
                        },
                        {
                            path: 'archive/manage',
                            name: 'ArchiveManage',
                            component: () => import(/* webpackChunkName: "dispenseRecipelRecord" */ './views/hospital/ArchiveManage.vue')
                        },
                        {
                            path: 'biosafety-cabinet',
                            name: 'BiosafetyCabinet',
                            component: () => import(/* webpackChunkName: "biosafetyCabinet" */ './views/device/BiosafetyCabinet.vue')
                        },
                        {
                            path: 'endoscope-brand-archive',
                            name: 'EndoscopeBrandArchive',
                            component: () => import(/* webpackChunkName: "endoscopeBrandArchive" */ './views/device/EndoscopeBrandArchive.vue')
                        },
                    ]
                },
                {
                    path: 'device',
                    name: 'Device',
                    meta: {
                        requireAuth: true,
                        name: '设备管理'
                    },
                    component: () => import(/* webpackChunkName: "DeviceIndex" */ './views/device/Index.vue'),
                    children: [
                        {
                            path: 'app',
                            name: 'App',
                            component: () => import(/* webpackChunkName: "deviceApp" */ './views/device/App.vue')
                        },
                        {
                            path: 'license',
                            name: 'License',
                            component: () => import(/* webpackChunkName: "deviceLicense" */ './views/device/Licenses.vue')
                        },
                        {
                            path: 'register',
                            name: 'Register',
                            component: () => import(/* webpackChunkName: "deviceRegister" */ './views/device/Register.vue')
                        },
                        {
                            path: 'malfunction',
                            name: 'Malfunction',
                            component: () => import(/* webpackChunkName: "deviceMalfunction" */ './views/device/Malfunctions.vue')
                        },
                        {
                            path: 'malf/calender',
                            name: 'MalfunctionCalender',
                            component: () => import(/* webpackChunkName: "deviceMalfunction" */ './views/device/MalfunctionCalendar.vue')
                        },
                        {
                            path: 'synclist',
                            name: 'SyncList',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/device/SyncList.vue')
                        },
                        {
                            path: 'key',
                            name: 'Key',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/device/Key.vue')
                        },
                        {
                            path: 'maintain/plan',
                            name: 'MaintainPlan',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/device/MaintainPlan.vue')
                        },
                        {
                            path: 'offine/sync',
                            name: 'OffineSync',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/device/OffineSync.vue')
                        },
                        // 以下是设备流程确认模块
                        {
                            path: 'check/flow',
                            name: 'CheckFlow',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/devCheck/Index.vue')
                        },
                        {
                            path: 'check/flow/uphold',
                            name: 'FlowUphold',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/devCheck/FlowUphold.vue')
                        },
                        {
                            path: 'check/flow/addAfter',
                            name: 'AddAfterDev',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/devCheck/AddAfterDev.vue')
                        },
                        {
                            path: 'check/flow/step',
                            name: 'FlowStepUphold',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/devCheck/FlowStepUphold.vue')
                        },
                        {
                            path: 'check/flow/project',
                            name: 'Project',
                            component: () => import(/* webpackChunkName: "synclist" */ './views/device/ProjectList.vue')
                        },
                        {
                            path: 'after-sales',
                            name: 'AfterSales',
                            component: () => import(/* webpackChunkName: "afterSales" */ './views/device/AfterSales.vue')
                        },
                    ]
                },
                {
                    path: 'statistic',
                    name: 'Statistic',
                    meta: {
                        requireAuth: true,
                        name: '统计分析'
                    },
                    component: () => import(/* webpackChunkName: "StatisticIndex" */ './views/statistic/index.vue'),
                    children: [
                        {
                            path: 'dispense',
                            name: 'DispenseSta',
                            component: () => import(/* webpackChunkName: "statisticDispense" */ './views/statistic/Dispense.vue')
                        },
                        {
                            path: 'malfunction',
                            name: 'MalfunctionSta',
                            component: () => import(/* webpackChunkName: "statisticMalfunction" */ './views/statistic/Malfunction.vue')
                        },
                        {
                            path: 'usage',
                            name: 'UsageSta',
                            component: () => import(/* webpackChunkName: "statisticMalfunction" */ './views/statistic/Usage.vue')
                        },
                        {
                            path: 'failure/info',
                            name: 'FailureInfo',
                            component: () => import(/* webpackChunkName: "statisticFailureInfo" */ './views/statistic/FailureInfo.vue')
                        },
                        {
                            path: 'fault/kanban',
                            name: 'FaultKanban',
                            component: () => import(/* webpackChunkName: "statisticFailureInfo" */ './views/statistic/FaultKanban.vue')
                        },
                        {
                            path: 'hospital/kanban',
                            name: 'HospitalKanban',
                            component: () => import(/* webpackChunkName: "statisticFailureInfo" */ './views/statistic/HospitalKanban.vue')
                        },
                        {
                            path: 'device/version',
                            name: 'DeviceVersionSta',
                            component: () => import(/* webpackChunkName: "statisticDeviceVersion" */ './views/statistic/DeviceVersion.vue')
                        },
                        {
                            path: 'device/stability',
                            name: 'StatisticDeviceStability',
                            component: () => import('@/views/statistic/DeviceStability.vue'),
                            meta: { title: '设备稳定性统计' }
                        },
                    ]
                },
                {
                    path: 'open-dev',
                    name: 'OpenDev',
                    meta: {
                        requireAuth: true,
                        name: '应用开发'
                    },
                    component: () => import(/* webpackChunkName: "opendevAppIndex" */ './views/opendev/App.vue'),
                    children: [
                        {
                            path: 'app',
                            name: 'App',
                            component: () => import(/* webpackChunkName: "opendevApp" */ './views/opendev/App.vue')
                        },
                    ]
                },
                {
                    path: 'user',
                    name: 'User',
                    meta: {
                        requireAuth: true,
                        name: '用户管理'
                    },
                    component: () => import(/* webpackChunkName: "userIndex" */ './views/user/Index.vue'),
                    children: [
                        {
                            path: 'profile',
                            name: 'UserProfile',
                            component: () => import(/* webpackChunkName: "userProfile" */ './views/user/Profile.vue')
                        },
                        {
                            path: 'info',
                            name: 'UserInfo',
                            component: () => import(/* webpackChunkName: "userInfo" */ './views/user/Info.vue')
                        },
                        {
                            path: 'role',
                            name: 'Role',
                            component: () => import(/* webpackChunkName: "userInfo" */ './views/user/Role.vue')
                        },
                        {
                            path: 'privilege',
                            name: 'Privilege',
                            component: () => import(/* webpackChunkName: "userPrivilege" */ './views/user/Privilege.vue')
                        },
                        {
                            path: 'loginlog',
                            name: 'LoginLog',
                            component: () => import(/* webpackChunkName: "userLoginLog" */ './views/user/LoginLog.vue')
                        },
                    ]
                },
                {
                    path: 'erp',
                    name: 'Erp',
                    meta: {
                        requireAuth: true,
                        name: '订单管理'
                    },
                    component: () => import('./views/erp/Index.vue'),
                    children: [
                        {
                            path: 'product',
                            name: 'ProductList',
                            component: () => import('./views/erp/ProductList.vue')
                        },
                        {
                            path: 'inventory',
                            name: 'ProductInventory',
                            component: () => import('./views/erp/ProductInventory.vue')
                        },
                        {
                            path: 'customer/manage',
                            name: 'CustomerManage',
                            component: () => import('./views/erp/CustomerManage.vue')
                        },
                        {
                            path: 'inventory/statistic',
                            name: 'ProductInventoryStatistic',
                            component: () => import('./views/erp/ProductInventoryStatistic.vue')
                        },
                        {
                            path: 'purchase/contract',
                            name: 'PurchaseContract',
                            component: () => import('./views/erp/PurchaseContract.vue')
                        },
                        {
                            path: 'sales/order',
                            name: 'SalesOrder',
                            component: () => import('./views/erp/SalesOrder.vue')
                        },
                        {
                            path: 'outbound/order',
                            name: 'OutboundOrder',
                            component: () => import('./views/erp/OutboundOrder.vue')
                        },
                        {
                            path: 'sales/return',
                            name: 'SalesReturnOrder',
                            component: () => import('./views/erp/SalesReturnOrder.vue')
                        },
                        {
                            path: 'quality/examine',
                            name: 'QualityExamine',
                            component: () => import('./views/erp/QualityExamine.vue')
                        }
                    ]
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/app',
            name: 'app',
            component: Login,
        },
        // {
        //   path: '/licenses',
        //   name: 'licenses',
        //   meta: {
        //     requireAuth: true
        //   },
        //   component: Licenses,
        // },
        {
            path: '/about',
            name: 'about',
            meta: {
                requireAuth: true
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        },
    ],
});
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next();
    }
    else {
        const token = localStorage.getItem('Authorization');
        if (token === 'null' || token === '') {
            next('/login');
        }
        else {
            next();
        }
    }
});
export default router;
